import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Layout from '../components/Layout'
import Login from '../components/Login'
import LoginLayout from '../components/LoginLayout'
import Dashboard from '../pages/Dashboard'

const RootRouter = () => {
  const routes = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <Dashboard />,
        },
      ],
    },
    {
      path: '/',
      element: <LoginLayout />,
      children: [
        {
          path: '/login',
          element: <Login />,
        },
      ],
    },
  ])
  return <RouterProvider router={routes} />
}

export default RootRouter
